<template>
  <div id="header">
    <b-navbar toggleable="xl" type="dark" id="mainnav" style="font-size: 18px;display: flex;width: 100%" class="navbar-expand-xl">
      <b-navbar-brand to="/">
        <img src="../assets/vumm.png" style="margin-left:10px;margin-top: -10px;height: 70px; vertical-align: auto" alt="Logo Museo Virtuale">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" v-model="showCollapse" is-nav>
        <b-navbar-nav class="ml-auto font-title1" fill>
<!--          <b-nav-item link-classes="navbaritemscolor" class="navbaritem" key="menu1" to="/">{{ $t("menu.home").toUpperCase() }}</b-nav-item>-->
          <b-nav-item-dropdown toggle-class="navbaritemscolor a-normal" :text="$t('menu.scopri').toUpperCase()">
            <b-dropdown-item link-class="a-normal" to="/cagranda">{{ $t("menu.scopri_cagranda").toUpperCase() }}</b-dropdown-item>
            <b-dropdown-item link-class="a-normal" to="/collectionsall">{{ $t("menu.scopri_sistemamuseale").toUpperCase() }}</b-dropdown-item>
            <b-dropdown-item link-class="a-normal" to="/buildings">{{ $t("menu.scopri_palazzi").toUpperCase() }}</b-dropdown-item>
            <b-dropdown-item link-class="a-normal" to="/archaeological">{{ $t("menu.scopri_scavi").toUpperCase() }}</b-dropdown-item>
            <b-dropdown-item link-class="a-normal" to="/archives">{{ $t("menu.scopri_archivi").toUpperCase() }}</b-dropdown-item>
            <b-dropdown-item link-class="a-normal" to="/orchestra">{{ $t("menu.scopri_orchestra").toUpperCase() }}</b-dropdown-item>
            <hr/>
            <b-dropdown-item link-class="a-normal" to="/inmuseums">{{ $t("menu.nei_musei").toUpperCase() }}</b-dropdown-item>
            <b-dropdown-item link-class="a-normal" to="/mapcollections">{{ $t("menu.collezioni_aperte").toUpperCase() }}</b-dropdown-item>
            <b-dropdown-item link-class="a-normal" to="/culturalprojects">{{ $t("menu.scopri_progetti").toUpperCase() }}</b-dropdown-item>
            <b-dropdown-item link-class="a-normal" to="/assetssearch">{{ $t("menu.ricerca").toUpperCase() }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item link-classes="navbaritemscolor a-normal" class="navbaritem" key="menu4" to="/googlearts">{{ $t("menu.google").toUpperCase() }}</b-nav-item>
<!--          <b-nav-item link-classes="navbaritemscolor" class="navbaritem" key="menu6" to="#">{{ $t("menu.documenti").toUpperCase() }}</b-nav-item>-->
          <b-nav-item link-classes="navbaritemscolor a-normal" class="navbaritem" key="menu5" to="/about">{{ $t("menu.credits").toUpperCase() }}</b-nav-item>
<!--          <b-nav-item-dropdown toggle-class="navbaritemscolor a-normal" :text="$t('menu.contatti').toUpperCase()">-->
<!--            <b-dropdown-item link-class="a-normal" to="/about">{{ $t("menu.chisiamo").toUpperCase() }}</b-dropdown-item>-->
<!--            <b-dropdown-item link-class="a-normal" to="/loans">{{ $t("menu.prestiti").toUpperCase() }}</b-dropdown-item>-->
<!--            <b-dropdown-item link-class="a-normal" to="/donors">{{ $t("menu.sostienici").toUpperCase() }}</b-dropdown-item>-->
<!--          </b-nav-item-dropdown>-->
          <b-nav-item to="/globalsearch"><b-icon style="color: white" icon="search"></b-icon></b-nav-item>
          <b-nav-item-dropdown toggle-class="navbaritemscolor a-normal" style="font-weight: 900; padding-left: 1rem" :text="$i18n.locale.toUpperCase()" left>
            <b-dropdown-item link-class="a-normal" href="#" @click="selectLang('it')">IT</b-dropdown-item>
            <b-dropdown-item link-class="a-normal" href="#" @click="selectLang('en')">EN</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>

import {store} from "core-js/internals/reflect-metadata";

let els = document.getElementsByClassName("navbaritem");
for (let i of els) {
  els[i].onclick = function () {
    document.getElementById("nav-collapse").collapse('hide');
  }
}

export default {
  data() {
    return {
      showCollapse: false
    }
  },
  created() {
    if (localStorage.getItem('locale'))
      this.$i18n.locale = localStorage.getItem('locale');
    else
      this.$i18n.locale = "it";
  },
  watch: {
    '$route' () {
      this.showCollapse = false
    }
  },
  methods: {
    store() {
      return store
    },
    async selectLang(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
    },
  }
}
</script>